interface CheckboxFilterOption {
  value: string;
  label: string;
}

interface CheckboxFilterProps {
  options: CheckboxFilterOption[];
  values: string[];
  onChange: (values: string[]) => void;
  onClear: () => void;
}

export function CheckboxFilter({
  options,
  values,
  onChange,
  onClear,
}: CheckboxFilterProps) {
  const hasFilter = values.length > 0;

  const toggleValue = (value: string) => {
    if (values.includes(value)) {
      onChange(values.filter((v) => v !== value));
    } else {
      onChange([...values, value]);
    }
  };

  const selectAll = () => {
    onChange(options.map((o) => o.value));
  };

  const deselectAll = () => {
    onChange([]);
  };

  return (
    <div className="min-w-[14rem] max-w-[20rem]">
      <div className="mb-2 flex items-center gap-2 text-xs text-gray-500">
        <button onClick={selectAll} className="hover:text-gray-700">
          Visi
        </button>
        <span>/</span>
        <button onClick={deselectAll} className="hover:text-gray-700">
          Jokio
        </button>
      </div>
      <div
        className={`space-y-0.5 ${options.length > 8 ? "max-h-48 overflow-y-auto" : ""}`}
      >
        {options.map((opt) => (
          <label
            key={opt.value}
            className="flex cursor-pointer items-center gap-2 rounded px-1 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
          >
            <input
              type="checkbox"
              checked={values.includes(opt.value)}
              onChange={() => toggleValue(opt.value)}
              className="h-3.5 w-3.5 rounded accent-primary-800"
            />
            {opt.label}
          </label>
        ))}
      </div>
      {hasFilter && (
        <div className="mt-2 border-t border-gray-100 pt-2 text-right">
          <button
            onClick={onClear}
            className="text-xs text-gray-500 hover:text-gray-700"
          >
            Išvalyti
          </button>
        </div>
      )}
    </div>
  );
}
